import {MessageBox} from 'element-ui';

/**
 * 一些标题
 * */
export const title = {
    deleteTitle: '确定要删除吗?',
    approved: '确定通过?',
    noApproved: '确定驳回?'
}

/**
 * 删除的提示信息 new Promise 传递一个用户是否操作的信息
 * @param title 提示标题
 * @return boolean true 用户确定  false 用户取消
 */
export function deleteTips(title) {
    return new Promise((resolve) => {
        MessageBox.confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            resolve(true);
        }).catch(() => {
            resolve(false);
        });
    })

}

/**
 * 提示信息 new Promise 传递一个用户是否操作的信息
 * @param title 提示标题
 * @return boolean true 用户确定  false 用户取消
 */
export function tips(title) {
    return new Promise((resolve) => {
        MessageBox.confirm(title, '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            resolve(true);
        }).catch(() => {
            resolve(false);
        });
    })

}

/**
 * 提示信息 new Promise 传递一个用户是否操作的信息
 * @param title 提示标题
 * @return boolean true 用户确定  false 用户取消
 */
export function alert(msg,title,option) {
    let options = {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }
    return new Promise((resolve) => {
        MessageBox.alert(msg, title || '提示', option || options).then(() => {
            resolve(true);
        }).catch(() => {
            resolve(false);
        });
    })

}
